module.exports = __webpack_public_path__ + "b490613c5f434b46ef8bf03eec95b5b2.svg";